/**
 * Modern Propane — showroom data & ZIP distance lookup
 */
(function (global) {
  'use strict';

  var STORES = {
    lodi: {
      key: 'lodi',
      label: 'Lodi',
      name: 'Lodi, NJ',
      addr: '199 US Highway 46, Lodi, NJ 07644',
      lat: 40.8752,
      lng: -74.069,
      phoneText: '(973) 778-0812',
      phoneHref: 'tel:+19737780812',
      hours: [
        { day: 'Mon – Sat', time: '8am – 7pm' },
        { day: 'Sunday', time: '9am – 5pm' }
      ],
      mapsUrl: 'https://www.google.com/maps/place/199+US-46,+Lodi,+NJ+07644',
      embedUrl: 'https://maps.google.com/maps?q=40.8752,-74.069&z=13&output=embed',
      services: 'Grills, propane tanks, refills & accessories'
    },
    toms: {
      key: 'toms',
      label: 'Toms River',
      name: 'Toms River, NJ',
      addr: '642 Fischer Blvd, Toms River, NJ 08753',
      lat: 39.9591,
      lng: -74.1259,
      phoneText: '(732) 228-7958',
      phoneHref: 'tel:+17322287958',
      hours: [
        { day: 'Mon – Fri', time: '9am – 7pm' },
        { day: 'Sat – Sun', time: '9am – 6pm' }
      ],
      mapsUrl: 'https://www.google.com/maps/place/642+Fischer+Blvd,+Toms+River,+NJ+08753',
      embedUrl: 'https://maps.google.com/maps?q=39.9591,-74.1259&z=13&output=embed',
      services: 'Grills, propane tanks, refills & accessories'
    }
  };

  var STORE_LIST = [STORES.lodi, STORES.toms];

  var PREFIX_COUNTY = {
    '109': { county: 'Rockland', state: 'NY', fallbackRes: 'Friday' },
    '125': { county: 'Orange', state: 'NY', fallbackRes: 'Friday' },
    '127': { county: 'Sullivan', state: 'NY', fallbackRes: 'Friday' },
    '070': { county: 'Essex', state: 'NJ', fallbackRes: 'Tuesday' },
    '071': { county: 'Essex', state: 'NJ', fallbackRes: 'Tuesday' },
    '072': { county: 'Union', state: 'NJ', fallbackRes: 'Tuesday' },
    '073': { county: 'Hudson', state: 'NJ', fallbackRes: 'Tuesday' },
    '074': { county: 'Passaic', state: 'NJ', fallbackRes: 'Wednesday' },
    '075': { county: 'Passaic', state: 'NJ', fallbackRes: 'Wednesday' },
    '076': { county: 'Bergen', state: 'NJ', fallbackRes: 'Monday' },
    '077': { county: 'Monmouth', state: 'NJ', fallbackRes: 'Monday' },
    '078': { county: 'Morris', state: 'NJ', fallbackRes: 'Wednesday' },
    '079': { county: 'Morris', state: 'NJ', fallbackRes: 'Thursday' },
    '080': { county: 'Camden', state: 'NJ', fallbackRes: 'Friday' },
    '081': { county: 'Camden', state: 'NJ', fallbackRes: 'Friday' },
    '082': { county: 'Atlantic', state: 'NJ', fallbackRes: 'Thursday' },
    '083': { county: 'Cumberland', state: 'NJ', fallbackRes: 'Thursday' },
    '084': { county: 'Atlantic', state: 'NJ', fallbackRes: 'Thursday' },
    '085': { county: 'Mercer', state: 'NJ', fallbackRes: 'Saturday' },
    '086': { county: 'Mercer', state: 'NJ', fallbackRes: 'Wednesday' },
    '087': { county: 'Ocean', state: 'NJ', fallbackRes: 'Tuesday' },
    '088': { county: 'Middlesex', state: 'NJ', fallbackRes: 'Wednesday' },
    '089': { county: 'Middlesex', state: 'NJ', fallbackRes: 'Saturday' }
  };

  var COUNTY_DELIVERY = {
    'Bergen|NJ': { days: ['Monday', 'Thursday'], withinWeek: false },
    'Essex|NJ': { days: ['Tuesday', 'Friday'], withinWeek: false },
    'Hudson|NJ': { days: ['Monday', 'Thursday'], withinWeek: false },
    'Hunterdon|NJ': { withinWeek: true },
    'Mercer|NJ': { days: ['Thursday'], withinWeek: false },
    'Middlesex|NJ': { days: ['Wednesday'], withinWeek: false },
    'Monmouth|NJ': { days: ['Wednesday'], withinWeek: false },
    'Morris|NJ': { days: ['Wednesday'], withinWeek: false },
    'Ocean|NJ': { days: ['Wednesday'], withinWeek: false },
    'Passaic|NJ': { days: ['Monday', 'Thursday'], withinWeek: false },
    'Somerset|NJ': { days: ['Friday'], withinWeek: false },
    'Sussex|NJ': { withinWeek: true },
    'Union|NJ': { days: ['Tuesday', 'Friday'], withinWeek: false },
    'Warren|NJ': { withinWeek: true },
    'Rockland|NY': { days: ['Thursday'], withinWeek: false },
    'Orange|NY': { days: ['Thursday'], withinWeek: false }
  };

  function residentialScheduleLabel(sched) {
    if (!sched) return '';
    if (sched.withinWeek) return 'within 1 week';
    if (!sched.days || !sched.days.length) return '';
    if (sched.days.length === 1) return sched.days[0];
    if (sched.days.length === 2) return sched.days[0] + ' & ' + sched.days[1];
    return sched.days.slice(0, -1).join(', ') + ' & ' + sched.days[sched.days.length - 1];
  }

  function grillDeliveryDisplay(resLabel) {
    if (!resLabel) return '';
    if (resLabel === 'within 1 week') return 'within 1 week';
    if (resLabel.indexOf('&') !== -1) {
      return resLabel
        .split(' & ')
        .map(function (day) {
          return day + 's';
        })
        .join(' & ');
    }
    return resLabel + 's';
  }

  function deliveryScheduleForZip(zip) {
    var prefix = String(zip || '').slice(0, 3);
    var loc = PREFIX_COUNTY[prefix];
    if (!loc) return null;
    var sched = COUNTY_DELIVERY[loc.county + '|' + loc.state];
    var res = sched ? residentialScheduleLabel(sched) : loc.fallbackRes;
    if (!res) return null;
    return { res: res, com: 'next business day' };
  }

  function isZip(z) {
    return /^\d{5}$/.test(String(z || '').trim());
  }

  function toRad(deg) {
    return (deg * Math.PI) / 180;
  }

  function distanceMiles(lat1, lng1, lat2, lng2) {
    var R = 3958.8;
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function formatDistance(miles) {
    if (miles < 1) return '< 1 mi';
    if (miles < 10) return miles.toFixed(1) + ' mi';
    return Math.round(miles) + ' mi';
  }

  function shortStoreAddress(store) {
    var street = store.addr.split(',')[0].replace('Highway', 'Hwy');
    return street + ', ' + store.label;
  }

  async function fetchZipCoords(zip) {
    try {
      var controller = new AbortController();
      var timeout = setTimeout(function () {
        controller.abort();
      }, 6000);
      var response = await fetch('https://api.zippopotam.us/us/' + encodeURIComponent(zip), {
        signal: controller.signal
      });
      clearTimeout(timeout);
      if (!response.ok) return null;
      var data = await response.json();
      if (!data.places || !data.places.length) return null;
      return {
        lat: parseFloat(data.places[0].latitude),
        lng: parseFloat(data.places[0].longitude)
      };
    } catch (err) {
      return null;
    }
  }

  async function findAllDistances(zip) {
    var coords = await fetchZipCoords(zip);

    if (!coords) {
      var z = String(zip);
      var southJerseyPrefixes = ['080', '081', '082', '083', '084', '085', '087', '088', '089'];
      var prefix3 = z.slice(0, 3);
      coords =
        southJerseyPrefixes.indexOf(prefix3) !== -1
          ? { lat: 39.95, lng: -74.2 }
          : { lat: 40.85, lng: -74.1 };
    }

    var lodiMiles = distanceMiles(coords.lat, coords.lng, STORES.lodi.lat, STORES.lodi.lng);
    var tomsMiles = distanceMiles(coords.lat, coords.lng, STORES.toms.lat, STORES.toms.lng);
    var store = lodiMiles <= tomsMiles ? STORES.lodi : STORES.toms;
    var miles = Math.min(lodiMiles, tomsMiles);

    return {
      store: store,
      miles: miles,
      lodiMiles: lodiMiles,
      tomsMiles: tomsMiles,
      distances: {
        lodi: lodiMiles,
        toms: tomsMiles
      }
    };
  }

  function saveZip(zip, storeKey) {
    if (!isZip(zip)) return;
    try {
      localStorage.setItem('mp_zip', String(zip).replace(/\D/g, '').slice(0, 5));
      if (storeKey) localStorage.setItem('mp_store', String(storeKey).slice(0, 20));
    } catch (e) {}
  }

  function loadZip() {
    try {
      return localStorage.getItem('mp_zip') || '';
    } catch (e) {
      return '';
    }
  }

  function getStore(key) {
    return STORES[key] || null;
  }

  global.MPStores = {
    STORES: STORES,
    STORE_LIST: STORE_LIST,
    isZip: isZip,
    formatDistance: formatDistance,
    shortStoreAddress: shortStoreAddress,
    findAllDistances: findAllDistances,
    deliveryScheduleForZip: deliveryScheduleForZip,
    grillDeliveryDisplay: grillDeliveryDisplay,
    saveZip: saveZip,
    loadZip: loadZip,
    getStore: getStore
  };
})(typeof window !== 'undefined' ? window : this);
